export const baseURL = 'https://api.vocabgpt.com.au';
// export const baseURL = 'https://dev.vocabgpt.com.au';
// export const baseURL = 'http://localhost';